import { render, staticRenderFns } from "./app-banner.vue?vue&type=template&id=585e12b8&scoped=true&"
import script from "./app-banner.vue?vue&type=script&lang=js&"
export * from "./app-banner.vue?vue&type=script&lang=js&"
import style0 from "./app-banner.vue?vue&type=style&index=0&id=585e12b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e12b8",
  null
  
)

export default component.exports